const DEFAULT_DWELL_SECONDS = 12;

// Resolve the date-range views to render. A slide configured before the
// dual-range feature (no `views`) falls back to a single, unfiltered range so it
// keeps rendering exactly as before (non-breaking).
const resolveViews = (
  slide: DriverLeaderboardSlide,
): DriverLeaderboardDateView[] => {
  if (slide.views && slide.views.length > 0) {
    return slide.views;
  }
  return [
    {
      id: `${slide.id}-default`,
      label: slide.name,
      dwellSeconds: DEFAULT_DWELL_SECONDS,
    },
  ];
};

export default resolveViews;
